/**
 * This is the application's run setup.
 * @memberOf Application Module
 * @namespace Application Run
 */

/**
 * @name config
 * @desc Setup the application.
 * @param $rootScope
 * @param $state
 * @param authenticationService
 * @memberOf Application Module.Application Run
 * @ngInject
 */
var run = function ($rootScope, $templateCache, $location, $window, coreService, $translate, $timeout, $transitions) {

  $transitions.onSuccess({}, function(transition){
    $rootScope.containerClass = 'container-' + transition.to().controller.replace("Controller", "");

    // update page title for WAI compliance
    $timeout(function(){
      //timeout required for $location service
      updatePageTitle($location, $translate, $window);
    })
  });

  $transitions.onStart({}, function(event, next, current) {
    if ($window.location.pathname !== '/'){
      $location.path($window.location.pathname);
    }
    let model = coreService.getIdentityModel();
    if (model.displayOnErrorPage){
      $location.path('error');
    }
   });

  let model = coreService.getIdentityModel();
  // Load translations and set window title.
  var ui_locales = (model.custom && model.custom.ui_locales) || model.ui_locales;
  if (ui_locales) {
    let setWindowTitle = function(x) { $window.document.title = x; };
    $translate.use(ui_locales).
      then(function(){
        // Set page title
        return $translate('application.login.title');
      }).
      then(setWindowTitle, setWindowTitle);
  }
};

// Function to update the page title on every state change
const updatePageTitle = function($location, $translate, $window) {
    let locationArray = $location.path().toLowerCase().split('/').filter(Boolean);
    let translationKey = 'application';
    let windowTitle = '';

    // set default window title to the product name. E.g. TD Card Management Tool
    $translate('application.title')
      .then(function(data) {
        windowTitle = data;
    });

    // create the angular translate key using the url
    locationArray.forEach(function(key) {
      translationKey +=  '.' + key;
    });    

    // find the angular translation and update the title
    $translate(translationKey)
      .then(function(data) {
          $window.document.title = windowTitle + ' | ' +  data;
      })
      .catch(function(err) {
        // if no translation is available then default to product name
        $window.document.title = windowTitle;
      });
}

export default run;


// WEBPACK FOOTER //
// ./src/app.run.js